import React from 'react';

function BottomPanel() {
  return <div />;
}

export default BottomPanel;
